import {
	EXPAND_CHANGED,
	ADD_ITEM_CLICKED,
	TIMELINE_MODE_CHANGED,
	useInteractionMetrics,
} from '../../../utils/interaction-metrics.tsx';

export const InteractionMetrics = () => {
	const interactionMetrics = useInteractionMetrics();

	if (interactionMetrics[ADD_ITEM_CLICKED].state === 'started') {
		// the time between add item clicked and inline create input is rendered in timeline
		interactionMetrics[ADD_ITEM_CLICKED].stop({ stopTime: Math.floor(performance.now()) });
	}

	if (interactionMetrics[TIMELINE_MODE_CHANGED].state === 'started') {
		// the time between timescale button clicked and timeline re-rendered
		interactionMetrics[TIMELINE_MODE_CHANGED].stop({ stopTime: Math.floor(performance.now()) });
	}

	if (interactionMetrics[EXPAND_CHANGED].state === 'started') {
		// the time between expand button clicked and timeline re-rendered
		interactionMetrics[EXPAND_CHANGED].stop({ stopTime: Math.floor(performance.now()) });
	}

	return null;
};
